var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-search",
    transform: "translate(1561 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 37,
    height: 37,
    transform: "translate(-1561 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6892",
    "data-name": "Path 6892",
    d: "M312.611,395.285c-.818-.8-3.8-3.762-5.139-5.075l.015-.017.009-.021a8.575,8.575,0,1,0-1.388,1.36l.161.157c.746.725,4.283,4.246,5.033,4.968a.948.948,0,0,0,1.585-.505A.942.942,0,0,0,312.611,395.285Zm-18.533-10.471a6.781,6.781,0,1,1,6.781,6.782A6.788,6.788,0,0,1,294.078,384.814Z",
    transform: "translate(-1844.721 -339.676)",
    fill: "#c1c1c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.7dc2196919de3f2e7937cc313a24b1ef.svg";
export { ForwardRef as ReactComponent };